"use strict"

import React, { useState } from "react"
import PropTypes from "prop-types"
import { useIntl } from "react-intl"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import { logToServer } from "../../../ErrorBoundary"
import { addNewObject } from "../../../Loaders"
import ModalAlterInventoryItem from "./ModalAlterInventoryItem"

export default function ModalAddInventoryItem(props) {
  const intl = useIntl()
  const [status_submit, setStatusSubmit] = useState(null)

  const onSubmit_add = (e, info) => {
    e.preventDefault()

    setStatusSubmit(API_STATUS.LOADING)
    const final_info = {
      ...info,
      action: "manual addition",
    }

    addNewObject(
      `/laboratory/inventory/inventory-item/${props.inventory_item.id}/adjust_quantity/`,
      final_info,
    )
      .then((_) => {
        setStatusSubmit(API_STATUS.SUCCESS)
        props.onSuccess()
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusSubmit(null)
        alert(intl.formatMessage({ id: "inventory.unable_to_submit" }))
      })
  }

  return (
    <ModalAlterInventoryItem
      onSubmit={(event, info) => onSubmit_add(event, info)}
      icon={"fa fa-plus"}
      btn_type={"btn-primary"}
      title_id={"general.add"}
      quantity_msg_id={"stock.quantity.to.add"}
      reason_msg_id={"stock.add.reason"}
      status={status_submit}
      {...props}
    />
  )
}

ModalAddInventoryItem.propTypes = {
  inventory_item: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
